"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsProvider_1 = require("../AnalyticsProvider");
var HondaProvider = /** @class */ (function (_super) {
    __extends(HondaProvider, _super);
    function HondaProvider(name, config) {
        var _this = _super.call(this, name) || this;
        _this.config = config;
        return _this;
    }
    HondaProvider.prototype.opened = function () {
        this.fireEvent(this.getEventObject("DRS-Start"));
    };
    HondaProvider.prototype.paymentCalcInteraction = function () {
        this.fireEvent(this.getEventObject("DRS-Payment-Calculator"));
    };
    HondaProvider.prototype.paymentCalcFinished = function () {
        this.fireEvent(this.getEventObject("DRS-Payment-Calculator-End"));
    };
    HondaProvider.prototype.tradeInFormStarted = function () {
        this.fireEvent(this.getEventObject("DRS-Trade-in"));
    };
    HondaProvider.prototype.tradeInFormFinished = function () {
        this.fireEvent(this.getEventObject("DRS-Trade-in-End"));
    };
    HondaProvider.prototype.testDriveFormStarted = function () {
        this.fireEvent(this.getEventObject("DRS-Test-Drive"));
    };
    HondaProvider.prototype.testDriveFormFinished = function () {
        this.fireEvent(this.getEventObject("DRS-Test-Drive-End"));
    };
    HondaProvider.prototype.softCreditFormFinished = function () {
        this.fireEvent(this.getEventObject("DRS-Credit-Application-End"));
    };
    HondaProvider.prototype.hardCreditFormFinished = function () {
        this.fireEvent(this.getEventObject("DRS-Credit-Application-End"));
    };
    HondaProvider.prototype.virtualPageView = function (pagePath) {
        this.fireEvent({
            page: pagePath,
            ProviderID: this.config.providerId,
            Dealerid: this.config.dealerId,
        });
    };
    HondaProvider.prototype.fireEvent = function (event) {
        window.dataLayer.push(event);
    };
    HondaProvider.prototype.getEventObject = function (event) {
        return {
            event: "drs",
            DRSType: event,
            ProviderID: this.config.providerId,
            Dealerid: this.config.dealerId,
        };
    };
    return HondaProvider;
}(AnalyticsProvider_1.AnalyticsProvider));
exports.default = HondaProvider;
